module.exports = __webpack_public_path__ + "img/user_avatar_default.fb86c9e9.png";